import { AnnouncementData } from '@ypp-portal/models/announcement/announcementData';
import { useThresholds } from '@util/customhooks/useThresholds';
import { truncateText } from '@util/truncateText';
import React from 'react';
import { Link } from 'react-router-dom';

interface AnnouncementProps {
  id: string;
  announcement: AnnouncementData;
}

const Announcement = ({ id, announcement: { created, title } }: AnnouncementProps) => {
  const { isAtLeastSmall } = useThresholds();

  const date = created.toDate();

  const TITLE_MAX_LEN = isAtLeastSmall ? 30 : 15;

  return (
    <div className='flex flex-row'>
      <Link
        to={`/announcements/${id}`}
        className='text-pewter underline font-raleway text-3xl text-center'
      >
        {truncateText(title, TITLE_MAX_LEN)}
      </Link>
      {isAtLeastSmall ? (
        <p className='text-3xl font-raleway pl-4'>({date.toLocaleDateString()})</p>
      ) : null}
    </div>
  );
};

export default Announcement;
